export const SCREEN_MIRRORING_EVENTS = {
	CLICK: 'SCREEN_MIRRORING_CLICK',
	LOAD_ALL_MESSAGES: 'SCREEN_MIRRORING_LOAD_ALL_MESSAGES',
	RESET_USER_NAVIGATION: 'SCREEN_MIRRORING_RESET_USER_NAVIGATION',
	SYNCHRONIZE_SCREENS: 'ON_SCREEN_MIRRORING_SYNCHRONIZATION',
	ON_WSSOCKET_RECONNECTION: 'ON_SCREEN_MIRRORING_WSSOCKET_RECONNECTION',
	ON_CLOSE_HOMEWORK_VIEWER: 'ON_SCREEN_MIRRORING_CLOSE_HOMEWORK_VIEWER',
	ON_OPEN_HOMEWORK_VIEWER: 'ON_SCREEN_MIRRORING_OPEN_HOMEWORK_VIEWER_{sectionId}',
	ON_OPEN_COURSE_TAB: 'ON_SCREEN_MIRRORING_OPEN_COURSE_TAB',
	ON_OPEN_SECTION_FOLDER: 'ON_SCREEN_MIRRORING_OPEN_SECTION_FOLDER_{sectionId}',
	ON_OPEN_SECTION_OBJECT: 'ON_SCREEN_MIRRORING_OPEN_SECTION_OBJECT_{sectionId}',

	ON_OPEN_PROJECT_FOLDER: 'ON_SCREEN_MIRRORING_OPEN_PROJECT_FOLDER_{projectId}',
	ON_OPEN_PROJECT_OBJECT: 'ON_SCREEN_MIRRORING_OPEN_PROJECT_OBJECT_{projectId}',

	ON_OPEN_SECTION_MATERIAL: 'ON_SCREEN_MIRRORING_OPEN_SECTION_MATERIAL_{sectionMaterialId}',
	ON_OPEN_SECTION_OBJECT_HOMEWORK: 'ON_SCREEN_MIRRORING_OPEN_SECTION_OBJECT_HOMEWORK_{sectionId}',
	ON_OPEN_COURSE: 'ON_SCREEN_MIRRORING_OPEN_COURSE_{courseId}_{classId}',
	ON_REFRESH_COURSE: 'ON_SCREEN_MIRRORING_REFRESH_COURSE',
	ON_GET_MORE_HOMEWORKS: 'ON_SCREEN_MIRRORING_GET_MORE_HOMEWORKS_{courseId}_{classId}',
	GO_TO_PAGE: 'GO_TO_PAGE',
};

export const SCREEN_MIRRORING_MESSAGE_TYPE = {
	CLICK_RESPONSE: 'ScreenMirrorClickResponse',
	LIST_RESPONSE: 'ScreenMirrorListResponse',
	CONNECT_RESPONSE: 'ScreenMirrorConnectResponse',
	DISCONNECT_RESPONSE: 'ScreenMirrorDisconnectResponse',
	DISCONNECT_USER_RESPONSE: 'ScreenMirrorDisconnectUserResponse',
	DISCONNECT_USER_REQUEST: 'disconnectUser',
};

export const SCREEN_MIRRORING_STORE_NAME = 'ScreenMirroringStore';

export const MUTATIONS = {
	SET_CLIENT_ID: 'setClientId',
	SET_MODE:'setMode',
}
  
export const _SCREEN_MIRRORING_STORE = {
	NAME: SCREEN_MIRRORING_STORE_NAME,
	MUTATIONS: {
		SET_CLIENT_ID: `${SCREEN_MIRRORING_STORE_NAME}/${MUTATIONS.SET_CLIENT_ID}`,
		SET_MODE: `${SCREEN_MIRRORING_STORE_NAME}/${MUTATIONS.SET_MODE}`,
	},
	ACTIONS: {}
}
